module.exports = __webpack_public_path__ + "img/bingo_ball-13.76e8bc96.png";